import { useEffect, useState } from "react";

export default function BackToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className={
        show
          ? "fixed bottom-6 right-5 z-40 flex h-11 w-11 cursor-pointer items-center justify-center rounded-full bg-foreground-950 text-background-50 shadow-lg transition-all hover:bg-primary-600"
          : "pointer-events-none fixed bottom-6 right-5 z-40 flex h-11 w-11 -translate-y-4 items-center justify-center rounded-full bg-foreground-950 text-background-50 opacity-0"
      }
    >
      <i className="ri-arrow-up-line text-lg" aria-hidden="true" />
    </button>
  );
}